// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_ColumnDragSourceArea {
  display: flex;
  margin-top: 0.5em;
  margin-bottom: 1em;
}
.CSVImporter_ColumnDragSourceArea__control {
  flex: none;
  display: flex;
  align-items: center;
}
.CSVImporter_ColumnDragSourceArea__page {
  position: relative;
  flex: 1 1 0;
  display: flex;
  padding-top: 0.5em;
  padding-left: 0.5em;
}
.CSVImporter_ColumnDragSourceArea__pageIndicator {
  position: absolute;
  top: -0.5em;
  right: 0;
  left: 0;
  text-align: center;
  font-size: 0.75em;
}
.CSVImporter_ColumnDragSourceArea__pageFiller {
  flex: 1 1 0;
  margin-right: 0.5em;
}
.CSVImporter_ColumnDragSourceArea__box {
  position: relative;
  flex: 1 1 0;
  margin-right: 0.5em;
  width: 0;
}
.CSVImporter_ColumnDragSourceArea__boxAction {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/fields-step/ColumnDragSourceArea.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;AADF;AAGE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;AAME;EACE,WAAA;EACA,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;AALJ;AAQE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AANJ","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_ColumnDragSourceArea {\n  display: flex;\n  margin-top: 0.5em;\n  margin-bottom: 1em;\n\n  &__control {\n    flex: none;\n    display: flex;\n    align-items: center;\n  }\n\n  &__page {\n    position: relative; // for indicator\n    flex: 1 1 0;\n    display: flex;\n    padding-top: 0.5em; // some room for the indicator\n    padding-left: 0.5em; // match interior box spacing\n  }\n\n  &__pageIndicator {\n    position: absolute;\n    top: -0.5em;\n    right: 0;\n    left: 0;\n    text-align: center;\n    font-size: 0.75em;\n  }\n\n  &__pageFiller {\n    flex: 1 1 0;\n    margin-right: 0.5em; // match interior box spacing\n  }\n\n  &__box {\n    position: relative; // for action\n    flex: 1 1 0;\n    margin-right: 0.5em;\n    width: 0; // prevent internal sizing from affecting placement\n  }\n\n  &__boxAction {\n    position: absolute;\n    top: 0; // icon button padding matches card padding\n    right: 0;\n    z-index: 1; // right above content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
